import { render, staticRenderFns } from "./CustomerCreateWizard.vue?vue&type=template&id=2aa466ac&scoped=true"
import script from "./CustomerCreateWizard.vue?vue&type=script&lang=ts"
export * from "./CustomerCreateWizard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCreateWizard.vue?vue&type=style&index=0&id=2aa466ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa466ac",
  null
  
)

export default component.exports